module.exports = __webpack_public_path__ + "static/media/3DPPA38.b22dd91d.jpg";